<template>
    <div class="align-middle">
        <toggle-button :key="toggleKey" v-model="toggleValue" @change="fnCallback" :color="color" :sync="true" :labels="labelsValue" />
    </div>
</template>
<script>
    import _ from "lodash";
    import { ToggleButton } from 'vue-js-toggle-button'

    /**
     * COMPONENTE DE CELDA DE TABLA PARA MOSTRAR Toggles SE PUEDE USAR EN LAS TABLAS O EN OTRO SITIO.
     * 
     * readTransform is a prop for custom the 'on/off' labels. It expects to receive a Json object like this: {"checked":"Yes", "unchecked":"No"}
     * */
    export default {
        name: "cell-dt-toggle-type-component",
        components: {
            ToggleButton
        },
        data() {
            return {
                toggleValue: this.value,
                labelsValue: true
            }
        },
        props: ['value', 'enabled', 'color', 'index', 'toggleKey', 'readTransform'], //['value', 'outcomes', 'format'],
        mounted() {
            if (this.readTransform) {
                let readedLabels = JSON.parse(this.readTransform);
                if (readedLabels.checked && readedLabels.unchecked)
                    this.labelsValue = readedLabels;
            }
        },
        methods: {
            fnCallback: function () {
                this.$emit('btn-click');
            }            
        }
    }

</script>
<style scoped>
    .cellBooleanType {
        text-align: center;
    }
</style>